export default __webpack_public_path__ + "static/media/del.d72bf0fb.svg";